import { ConsoleSqlOutlined } from '@ant-design/icons'
import { calidadDatosMapper, porcRespuestasMapper } from '../dashHelper'
import { getCommonWidget } from '../dashWidgetHelper'
import { widgetsLibrary } from '../widgetsLibrary/widgetsLibrary'

export const CJ_JAC_ORDER: any = {
  10365: 0, // Recepción,
  10366: 1, // Atención y amabilidad,
  10367: 2, // Conocimiento,
  10368: 3, // Instalaciones,
  10369: 4, // Entrega,
  10372: 0, // NPS - Mantenimiento
  10373: 1, // Atención y amabilidad,
  10374: 2, // Recepción,
  10375: 3, // Seguimiento
  10376: 4, // Entrega
  10377: 5, // Tasa de retorno
}

export const JAC_GREEN_1 = '#88DD76'
export const JAC_GREEN_2 = '#AEDD76'
export const JAC_ORANGE = '#F3AF5A'
export const JAC_BLUE = '#8CF0EA'
export const JAC_RED_2 = '#DB7476'
export const JAC_RED_1 = '#CD4245'
export const JAC_YELLOW = '#F1E713'


export const COLORS_CONFIG = [
  {
    color: JAC_RED_1,
    condition: '<=' as const,
    key: 'value',
    value: 39,
  },
  {
    color: JAC_ORANGE,
    condition: '>' as const,
    key: 'value',
    value: 39,
  },
  {
    color: JAC_GREEN_1,
    condition: '>' as const,
    key: 'value',
    value: 70,
  },
]

// FIXME: la idea es ir mapeando los workflows con los distintos CM  ya que depende el caso, un MC tiene varios wkf
// o un wf tiene varios MC  y si queremos o necesitamo armar dash mas especificos por ejemplo venta_hyp no podemos obtener el wkf puntual con el CM 
// Tal vez la solucioin mas robusta seria tocal el back para hacer estas asociaciones.
// si queda asi, hay que integralo con la funcion getCmID

const workflows: { id: number[]; code: string; workflows: string }[] = [
    { id: [9951], code: 'venta', workflows: 'venta,venta_electrico,venta_gasolina' },
    { id: [14302], code: 'postventa', workflows: 'postventa,postventa_hyp,postventa_garantias' }, // postventa_otros se deja afuera porque no se hacen envios
    { id: [13651], code: 'ISD', workflows: 'isd_duenos,isd_gerente_general,isd_gerente_postventa,isd_gerente_ventas,isd_director_marca' },
    { id: [11507,11511,11509,11510,11512,11513], code: 'KOX', workflows: 'primer_contacto,segundo_contacto,tercer_contacto,cuarto_contacto' },
    { id: [12901], code: 'Flotillas', workflows: 'postventa_flotillas'},
    { id: [9952], code: 'Postventa', workflows: 'postventa' },
    { id: [14304], code: 'Garantias', workflows: 'postventa_garantias' },
    { id: [14303], code: 'HyP', workflows: 'postventa_hyp' },
    
  ];

export const getWorkflowsById = (id: number): string | undefined=> {
    const match = workflows.find(item => item.id.includes(id))
    return match?.workflows ??  undefined
}
  
export const getWorkflows = (code: string): string | undefined => {
  
  const match = workflows.find(item => item.code === code)
  return match?.workflows ?? undefined 
}



export const getCmID = (code: string | undefined): number => {
  const criticals: { code: string, id: number }[] = [
    { code: 'venta', id: 9951 },
    { code: 'servicio', id: 14302 },
    { code: 'postventa', id: 14302 },
    { code: 'koxDPC', id: 11512 },
    { code: 'koxDSC', id: 11513 },
    { code: 'koxEPC', id: 11509 },
    { code: 'koxESC', id: 11510 },
    { code: 'ISD', id: 13651 },
    { code: 'Usabilidad', id: 11506 },
    { code: 'Retail', id: 14301 },
    { code: 'Estatico', id: 11507 },
    { code: 'Dinamico', id: 11511 },
    { code: 'Postventa', id: 9952 }, //ojo con el nombre
    { code: 'Flotillas', id: 12901 },
    { code: 'Garantias', id: 14304 },
    { code: 'HyP', id: 14303 },
  ]

  const match = criticals.find(item => item?.code === code)
  return match ? match.id : 29
}


export const jacCustomerJourneyMapper = (data: any, extra: any) => {
  //console.log('JAC CUSTOMER JORUNEY!!!')
  //console.log(data)

  const accumulated = data.reduce((acc: any, curr: any) => {
    const groupName = curr?.group?.trim()
    const group = curr?.group?.trim()
      ?.normalize('NFD')
      ?.replace(/[\u0300-\u036f]/g, "")
      ?.replace(/\s+/g, '')
    const prevValue = acc[group]?.value ?? 0
    const prevCounter = acc[group]?.counter ?? 0
    const value = curr?.value + prevValue
    const counter = prevCounter + 1
    const groupIds = [...(acc[group]?.groupIds ?? []), curr.groupId]

    return {
      ...acc,
      [group]: {
        ...(acc[group] ?? {}),
        value: value,
        counter: counter,
        groupIds: groupIds,
        label: groupName,
        weight: CJ_JAC_ORDER[curr?.groupId] ?? acc[group]?.weight
      }
    };
  }, {})

  return Object.values(accumulated).map((item: any) => {
    return {
      ...item,
      value: item.value / item.counter,
      //label: 'widgets.indicatorId.' + item.groupId,
      //weight: CJ_JAC_ORDER[item.groupId] ?? CJ_JAC_ORDER,
    }
  }).sort((item1: any, item2: any) => item1.weight - item2.weight)
}

export const jacGaugeCountNumberMapper = (data: any) => {
  //console.log('jacGaugeCountNumberMapper!!!')
  //console.log(data)

  const total = data?.reduce((acc: any, curr: any) => acc + curr?.count, 0) ?? 0
  const satisfecho = data?.find((item: any) => item?.groupId === 4)?.value ?? 0
  const muySatisfecho = data?.find((item: any) => item?.groupId === 5)?.value ?? 0
  /*const value = total > 0 
  ? (satisfecho + muySatisfecho / total) 
  : (satisfecho + muySatisfecho)*/

  const value = satisfecho + muySatisfecho

  //console.log(`valores satisfecho=${satisfecho} muySatisfecho=${muySatisfecho} total=${total} res=${value}`)

  return value
}

export const jacGaugeCount10NumberMapper = (data: any) => {
  //console.log('jacGaugeCount10NumberMapper')
  //console.log(data)

  const total = data?.reduce((acc: any, curr: any) => acc + curr?.count, 0) ?? 0

  const satisfecho = data
    ?.filter((item: any) => item?.groupId === 7 || item?.groupId === 8)
    .reduce((acc: any, curr: any) => acc + curr?.count, 0) ?? 0

  const muySatisfecho = data
    ?.filter((item: any) => item?.groupId === 9 || item?.groupId === 10)
    .reduce((acc: any, curr: any) => acc + curr?.count, 0) ?? 0

  //console.log(satisfecho)
  //console.log(muySatisfecho)

  const value = total > 0
    ? (satisfecho + muySatisfecho) / total * 100
    : (satisfecho + muySatisfecho)

  return value
}

export const jacGaugeCount9_10NumberMapper = (data: any) => {
  const total = data?.reduce((acc: any, curr: any) => acc + curr?.count, 0) ?? 0

  const value = data
    ?.filter((item: any) => item?.groupId === 9 || item?.groupId === 10)
    .reduce((acc: any, curr: any) => acc + curr?.count, 0) ?? 0

  const result = total > 0
    ? (value) / total * 100
    : (value)

  return result
}


export const jacGaugeCount5NumberMapper = (data: any) => {
  
  if(data.length === 0) {
    return undefined
  }

  const total = data?.reduce((acc: any, curr: any) => acc + curr?.count, 0) ?? 0

  const satisfecho = data
    ?.filter((item: any) => item?.groupId === 4)
    .reduce((acc: any, curr: any) => acc + curr?.count, 0) ?? 0

  const muySatisfecho = data
    ?.filter((item: any) => item?.groupId === 5)
    .reduce((acc: any, curr: any) => acc + curr?.count, 0) ?? 0

  const value = total > 0
    ? (satisfecho + muySatisfecho) / total * 100
    : (satisfecho + muySatisfecho)

  return value
}

export const commonWidgets: CommonWidget = {
  jacGaugeSingleton: {
    title: 'FALTA',
    // [Column, Row]
    position: [0, 0],
    size: [0, 0],
    config: {
      id: 'gauge-generic',
      type: 'gauge',
      fillMode: '',
      color: '#33b9ce',
      showValues: true,
      showHistoric: false,
      maxValue: 100,
      decimals: 1,
      center: ['50%', '50%'],
      radius: '90%',
      indicators: [
        {
          indicator: 'FALTA',
          keyExtract: ['value', 'group', 'groupId', 'count'],
          value: 'value',
          dataType: 'list',
          singleton: true,
          extras: {
            groupNameFormat: 'description',
          },
        },
      ],
    },
  },
  ...widgetsLibrary
}

const getCJIndicators = (indicatorsConfig: { [key: string]: any }) => {

  //console.log('getCJIndicators') 
  //console.log(indicatorsConfig)
  return Object.keys(indicatorsConfig).map(key => ({

    indicator: indicatorsConfig[key].name,
    grouped: undefined,
    keyExtract: ['group', 'value', 'groupId', 'count'],
    label: 'group',
    value: 'value',
    singleton: true,
    extras: {
      groupNameFormat: 'description',
      formula: indicatorsConfig[key].formula ?? undefined,
      ...indicatorsConfig[key].extrasFechas ?? undefined,
      criticalMomentInclude: indicatorsConfig[key].criticalMomentInclude ?? undefined
    },
  }));
};

const defaulMapperJacCustomerJourney = (data: any, extra: any) => {
  return Object.keys(data).flatMap((key) => {

    var value = jacGaugeCount5NumberMapper(data[key]) //ojo aca, estaba el de base 10 para kox
    var label = `widgets.${key}`
    return {
      value: value,
      name: key,
      label: label
    }

  });
}

export const postVentaMapperJacCustomerJourney = (data: any, extra: any) => {
  return Object.keys(data).flatMap((key) => {
    var value 
    if (key === 'Reparacion_CSI' || key === 'Avance_CSI'){
        value = data[key]?.[1]?.value ?? 0 
    } else { 
        value = jacGaugeCount9_10NumberMapper(data[key])
    }
    
    var label = `widgets.${key}`
    return {
      value: value,
      name: key,
      label: label
    }
  });
}

export const ventaMapperJacCustomerJourney = (data: any, extra: any) => {
  return Object.keys(data).flatMap((key) => {
    var value = jacGaugeCount9_10NumberMapper(data[key])
    var label = `widgets.${key}`
    
    return {
      value: value,
      name: key,
      label: label
    }
  });
}

export const getJacCustomerJourney = (props: {
  id: string
  indicators: { [key: string]: any },
  position?: number[],
  size: number[],
  title?: string,
  helpText?: string,
  extraConfigs?: { [key: string]: any },
  extras?: { [key: string]: any },
  mapper?: (data: any, extra: any) => any
  render?: (filters: FiltersUI, filtersData?: Record<string, any>) => boolean,
  criticalMomentInclude?: number[]
}) => {
  const {
    id,
    indicators,
    position,
    size,
    title,
    helpText,
    extraConfigs,
    extras,
    mapper,
    render,
    criticalMomentInclude
  } = props
  return {
    title: title,
    position: position,
    size: size,
    helpText: helpText ?? "Métricas calculadas como la suma de 'Satisfecho' y 'Muy Satisfecho' sobre el total de encuestas.",
    showHelp: true,
    extras,
    criticalMomentInclude,
    //extraConfigs: extraConfigs,
    render: render,
    config: {
      id: id,
      type: 'multipleGauge',
      fillMode: '',
      maxValue: 100,
      labelFontSize: 40,
      colors: COLORS_CONFIG,
      showValues: true,
      showHistoric: false,
      mapper: mapper ?? defaulMapperJacCustomerJourney,
      indicators: getCJIndicators(indicators),
      ...extraConfigs,
    },
  }
}

export const getJacCustomerJourneyVentaWidget = () => {
  return getCommonWidget({
    commonWidgets: commonWidgets,
    key: 'customerJourneyVenta',
    name: 'multipleGaugeByQuestion',
    title: 'widgets.customerJourneyVenta',
    mapper: jacCustomerJourneyMapper,
    //indicator: 'VENTA_CUSTOMER_JOURNEY',
    indicator: 'MERGE',
    position: [0, 8],
    size: [4, 2],
    extraConfigs: {
      chartRadius: '85%',
      groupNameFormat: 'description',
      maxValue: 100,
    },
    extras: {
      indicators: 'VENTA_RECEPCION,VENTA_ATENCION,VENTA_EXPLICACION,VENTA_INSTALACIONES,VENTA_ENTREGA',
    },
    criticalMomentInclude: [getCmID('venta')],
  })
}

export const getJacCalidadDatosWidget = (cm: number) => {
    return getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'gaugeGenericByStatus',
        title: `widgets.calidadDatos`,
        position: [2, 6],
        size: [1, 2],
        indicator: 'calidad-gauge',
        //indicator: 'survey-response-counters',
        key: `${cm}-calidad-datos-gauge`,
        mapper: calidadDatosMapper,
        criticalMomentInclude: [cm],
        url: 'dashboard/status',
        extraIndicatorConfigs: {
            keyExtract: ['resume'],
            singleton: true
        },
        extras: {
            useLcmApi: true,
            workflowNameInclude: getWorkflowsById(cm)
        },

    })
}

export const getJacPorcRespuestasWidget = (cm: number) => {
    return getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'gaugeGenericByStatus',
        title: `widgets.porcRespuestas`,
        //indicator: 'survey-response-counters',
        key: `${cm}-porc-respuestas-gauge`,
        mapper: porcRespuestasMapper,
        criticalMomentInclude: [cm],
        indicator: 'calidad-gauge',

        url: 'dashboard/status',
        extraIndicatorConfigs: {
            keyExtract: ['resume'],
            singleton: true
        },
        extras: {
            useLcmApi: true,
            workflowNameInclude: getWorkflowsById(cm)
        },

        position: [3, 4],
        size: [1, 2],
    })
}

export const getJacNpsVentaWidget = () => {
  return getCommonWidget({
    commonWidgets: commonWidgets,
    name: 'multipleTrendByMonth',
    title: 'widgets.npsVenta',
    position: [0, 6],
    size: [2, 2],
    indicator: 'VENTA_CSAT',
    criticalMomentInclude: [getCmID('venta')],
    extras: {
      periods: 6,
      formula: 'nps-10'
    }
  })
}